'use client';
import { jsx } from 'react/jsx-runtime';

function PointLabel({ x, y, value }) {
  return /* @__PURE__ */ jsx("g", { transform: `translate(${x},${y})`, children: /* @__PURE__ */ jsx(
    "text",
    {
      x: 0,
      y: 0,
      dy: -8,
      dx: -10,
      textAnchor: "top",
      fill: "var(--chart-text-color, var(--mantine-color-dimmed))",
      fontSize: 8,
      children: value
    }
  ) });
}

export { PointLabel };
//# sourceMappingURL=PointLabel.mjs.map
